/**
 * Moved to `shared/src/review/freshness-serp-compare.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  FRESHNESS_LABEL,
  FRESHNESS_SIX_MONTHS_MS,
  FRESHNESS_TWO_YEARS_MS,
  comparePageFreshnessToSerp,
  formatFreshnessDateLabel,
  freshnessDiagnosisLabel,
  freshnessDiagnosisTone,
  medianPublishedDate,
  pageContentLastModifiedLabel,
  parsePageContentLastModifiedDate,
  serpWinnerPublishedDatesFromResults
} from '@taptimize/shared/dist/review/freshness-serp-compare';
export type {
  FreshnessDiagnosisLabel,
  FreshnessDiagnosisTone,
  FreshnessSerpCompareResult,
  FreshnessSerpRelation,
  SerpPublishedDateRow
} from '@taptimize/shared/dist/review/freshness-serp-compare';
